import { DayStatusModel } from "./day-status.model";

export class WorkingHrModel {
    employeeCode: string;
    employeeName: string;
    department: string;
    contractorName: string;
    shift: string;
    workStation: string;
    dayStatus: DayStatusModel[];
    unitName: string;
    totalAllHours?:string;
   /**
    * 
    * @param employeeCode 
    * @param employeeName 
    * @param department 
    * @param contractorName 
    * @param shift 
    * @param workStation 
    * @param dayStatus 
    * @param totalHours 
    * @param totalAllHours 
    */

    constructor(employeeCode: string, employeeName: string, department: string, contractorName: string, shift: string, workStation: string, dayStatus: DayStatusModel[],totalAllHours?:string ) {

        this.employeeCode = employeeCode;
        this.employeeName = employeeName;
        this.department = department;
        this.contractorName = contractorName;
        this.shift = shift;
        this.workStation = workStation;
        this.dayStatus = dayStatus;
        this.totalAllHours = totalAllHours;

    }
}